import { render, staticRenderFns } from "./LargePostCard.vue?vue&type=template&id=acf89a64&scoped=true"
import script from "./LargePostCard.vue?vue&type=script&lang=js"
export * from "./LargePostCard.vue?vue&type=script&lang=js"
import style0 from "./LargePostCard.vue?vue&type=style&index=0&id=acf89a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf89a64",
  null
  
)

export default component.exports